<template>
  <form @submit.prevent="submit" class="contract-form uk-form-stacked">
    <!-- Basic Data -->
    <fieldset class="uk-fieldset uk-margin-medium-top">
      <legend class="uk-legend">{{$t('fieldsets.basicFields')}}</legend>

      <text-input
        :disabled="!isEditable"
        :errors="fields.errors.name"
        :label="$t('fields.name')"
        ref="name"
        v-model="fields.values.name"
      />

      <text-input
        :disabled="!isEditable"
        :errors="fields.errors.contractNumber"
        :label="$t('fields.contractNumber')"
        ref="contractNumber"
        v-model="fields.values.contractNumber"
      />

      <enum-input
        :errors="fields.errors.provider"
        :label="$t('fields.provider')"
        :options="availableProviders"
        v-model="fields.values.provider"
      />
    </fieldset>

    <!-- Details -->
    <fieldset class="uk-fieldset uk-margin-medium-top">
      <legend class="uk-legend">{{$t('fieldsets.details')}}</legend>

      <duration-input
        :disabled="!isEditable"
        :errors="fields.errors.contractDuration"
        :label="$t('fields.contractDuration')"
        v-model="fields.values.contractDuration"
      />

      <text-list-input
        :disabled="!isEditable"
        :errors="fields.errors.usps"
        :label="$t('fields.usps')"
        v-model="fields.values.usps"
      />

      <text-list-input
        :disabled="!isEditable"
        :errors="fields.errors.summaryTexts"
        :label="$t('fields.summaryTexts')"
        v-model="fields.values.summaryTexts"
      />
    </fieldset>

    <!-- SEO -->
    <fieldset class="uk-fieldset uk-margin-medium-top">
      <legend class="uk-legend">{{$t('fieldsets.seo')}}</legend>

      <text-input
        :disabled="!isEditable"
        :errors="fields.errors.slug"
        :label="$t('fields.slug')"
        :placeholder="slugPlaceholder"
        v-model="fields.values.slug"
      />

      <keyword-list-input
        :disabled="!isEditable"
        :errors="fields.errors.keywords"
        :label="$t('fields.keywords')"
        v-model="fields.values.keywords"
      />
    </fieldset>

    <!-- Legal Texts -->
    <fieldset class="uk-fieldset uk-margin-medium-top">
      <legend class="uk-legend uk-margin">{{$t('fieldsets.legalTexts')}}</legend>

      <legal-text-manager
        :disabled="!isEditable"
        :errors="fields.errors.legalTexts"
        v-model="fields.values.legalTexts"
      />
    </fieldset>

    <!-- Media -->
    <fieldset class="uk-fieldset uk-margin-medium-top">
      <legend class="uk-legend uk-margin">{{$t('fieldsets.media')}}</legend>

      <attachment-manager
        :disabled="!isEditable"
        :errors="fields.errors.media"
        attachment-type="MEDIA_OBJECT"
        v-model="fields.values.media"
      />
    </fieldset>

    <div class="uk-margin-medium-top">
      <submit-button :disabled="!isSubmittable" type="primary" />
      <cancel-button />
    </div>
  </form>
</template>

<script>
import AttachmentManager from '@/components/AttachmentManager';
import CancelButton from '@/components/CancelButton';
import DurationInput from '@/components/DurationInput';
import EnumInput from '@/components/EnumInput';
import Form from '@/mixins/Form';
import KeywordListInput from '@/components/KeywordListInput';
import LegalTextManager from '@/components/LegalTextManager';
import slugQuery from '@/api/queries/slug.graphql';
import SubmitButton from '@/components/SubmitButton';
import TextInput from '@/components/TextInput';
import TextListInput from '@/components/TextListInput';

const PROVIDERS = ['TVPP'];

export default {
  name: 'contract-form',
  components: {
    AttachmentManager,
    CancelButton,
    DurationInput,
    EnumInput,
    KeywordListInput,
    LegalTextManager,
    SubmitButton,
    TextInput,
    TextListInput,
  },
  mixins: [
    Form({
      contractDuration: { type: Form.Types.NullableObject },
      contractNumber: { required: true },
      name: { required: true },
      keywords: { type: Form.Types.Array },
      legalTexts: { type: Form.Types.ReferenceList },
      media: { type: Form.Types.ReferenceList, dumpTo: 'mediaObjectIds' },
      provider: true,
      slug: true,
      summaryTexts: { type: Form.Types.Array },
      usps: { type: Form.Types.Array },
    }),
  ],
  mounted() {
    this.$refs.name.focus();
  },
  computed: {
    availableProviders() {
      return PROVIDERS.map(provider => ({
        label: this.$t(`providers.${provider}`),
        value: provider,
      }));
    },
  },
  apollo: {
    slugPlaceholder: {
      query: slugQuery,
      variables() {
        return { value: this.fields.values.name };
      },
      fetchPolicy: 'network-only',
      debounce: { wait: 500 },
      update({ slug }) {
        return slug;
      },
      skip() {
        return !this.fields.values.name;
      },
    },
  },
};
</script>



// WEBPACK FOOTER //
// ContractForm.vue?432c4466